import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "mobile-only" }
const _hoisted_4 = { class: "desktop-only" }
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "mobile-only" }
const _hoisted_7 = { class: "desktop-only" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Pregledi',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.pregledi.title'),
    cover: require('@/assets/covers/pregledi-narrow.jpg'),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/child-on-chair.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.pregledi.intro')), 1),
        _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('articles.pregledi.childrenTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/boy-on-chair.jpg'),
          float: "left"
        }, null, 8, ["image"]),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('articles.pregledi.childrenTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.pregledi.childrenP1')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.pregledi.childrenP2')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.pregledi.childrenP3')), 1)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('articles.pregledi.adultsTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/photos/xray-small.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('articles.pregledi.adultsTitle')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t('articles.pregledi.adultsP1')
        }, null, 8, _hoisted_8),
        _createElementVNode("p", null, [
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'parodontologija')))
          }, _toDisplayString(_ctx.$t('articles.pregledi.adultsP2ParodontalDisease')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.pregledi.adultsP2body')), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'ortopan')))
          }, _toDisplayString(_ctx.$t('articles.pregledi.adultsP3Xray')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.pregledi.adultsP3body')), 1)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.pregledi.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'splosno')))
          }, _toDisplayString(_ctx.$t('articles.pregledi.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.pregledi.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})